import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-to-renew',
    templateUrl: './to-renew.component.svg',
    styleUrls: ['./to-renew.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToRenewComponent {}
